import React from "react";
import { css } from "aphrodite";
import { styles } from "./SearchPageStyle";
import Button from "reactstrap/lib/Button";
import { YearPicker } from "src/components/YearPicker";
import OutsideClickHandler from 'react-outside-click-handler';
import Select from "react-dropdown-select";
import { FundingAgency } from "src/models/FundingAgency";
import axios from "axios";
import { URLBuilder } from "src/core/URLBuilder";
import { JsonConvert } from "json2typescript";
import { SearchOptions } from "src/models/SearchOptions";

interface ISearchPageProps {
    history: any
}

class SearchPageState {
    public readonly firstName: string = "";
    public readonly lastName: string = "";
    public readonly keyphrase: string  = "";
    public readonly isSponsorSelected: boolean = true;
    public readonly isFacultySelected: boolean = true;
    public readonly isProposalAwardSelected: boolean = true;
    public readonly isPublicationSelected: boolean = true;
    public readonly isTitleSelected: boolean = true;
    public readonly isAbstractSelected: boolean = true;
    public readonly startYear: number = 2010;
    public readonly endYear: number = 2019;
    public readonly isStartYearDialogVisible: boolean = false;
    public readonly isEndYearDialogVisible: boolean = false;
    public readonly agencies: FundingAgency[] = []
    public readonly selectedAgencies: FundingAgency[] = []
    public readonly isInputFieldError: boolean = false;
    public readonly inputFieldError: string = ""
}

export class SearchPage extends React.Component<ISearchPageProps, SearchPageState> {
    
    constructor(props: ISearchPageProps){
        super(props);
        this.state = new SearchPageState();
    }

    public async componentDidMount() {
        axios.get(URLBuilder.funding_agency()).then((res)=>{
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserialize(res.data, FundingAgency);
                    this.setState({...this.state, agencies: data});
                }catch(error){
                    console.log(error);
                }
            }else{
                //error
                console.log(res.statusText)
            }
        }).catch((error)=>{
            console.log(error)
        })
    }

    public render() {

        let startYearDropDownContentStyle;
        if(this.state.isStartYearDialogVisible){
            startYearDropDownContentStyle = {
                display: "block"
            }
        }else{
            startYearDropDownContentStyle = {
                display: "none"
            }
        }

        let endYearDropDownContentStyle;
        if(this.state.isEndYearDialogVisible){
            endYearDropDownContentStyle = {
                display: "block"
            }
        }else{
            endYearDropDownContentStyle = {
                display: "none"
            }
        }

        let inputFieldStyle;
        if(this.state.isInputFieldError){
            inputFieldStyle = {
                marginTop: "10px",
                marginBottom: "10px",
                color: "red"
            }
        }else{
            inputFieldStyle = {
                display: "none"
            }
        }

        return (
            <div id="page" className={css(styles.page)} >
                
                <h2 className={css(styles.sectionlabel)}>
                    Advanced Search
                </h2>

                <div id="search_fields_container" className={css(styles.searchForContainer)}  >

                    <div>
                        <div className={css(styles.subSectionlabel)} >
                            Investigator
                        </div>
                        <input type="text" width="200" placeholder={"First Name"} value={this.state.firstName} onChange={this.onFirstNameChange} style={{
                            marginBottom: "10px"
                        }}/>
                        <input type="text" width="200" placeholder={"Last Name"}  value={this.state.lastName} onChange={this.onLastNameChange} />                    
                    </div >
                    
                    <div>
                        {/*<div className={css(styles.subSectionlabel)} >
                            OR
                        </div>

                        <div id="seperator" className={css(styles.seperator)} >

                        </div>
                        */}
                    </div>
                     
                    
                    <div>
                        <div className={css(styles.subSectionlabel)} >
                            Keyphrase
                        </div>
                        <input
                            type="text"
                            placeholder="Enter any keyphrase to search"
                            className={css(styles.keyphrase)}
                            value={this.state.keyphrase}
                            onChange={this.onKeyPhraseChanged}
                        />
                    </div>
                </div>

                <div className={css(styles.sectionlabel)} >
                    Search in (Pick at least one from each column below)
                </div>
                <div id="search_fields_container" className={css(styles.searchInContainer)}  >
                    <div>
                    {/*
                        <div id="search_option_faculty" className={css(styles.searchInOption)} >
                            <input id="cb_field_faculty" type="checkbox"  onChange={this.onFacultyChanged}  />
                            <label htmlFor="cb_field_faculty">Faculty</label>
                        </div>

                        <div id="search_option_sponsor" className={css(styles.searchInOption)} >
                           <input id="cb_field_sponsor" type="checkbox"  onChange={this.onSponsorChanged}  />
                           <label htmlFor="cb_field_sponsor">Sponsors</label>
                        </div>
                     */}
                        <div id="search_option_proposal_awards" className={css(styles.searchInOption)}>
                            <input id="cb_field_proposal_awards" type="checkbox"  onChange={this.onProposalAwardsChanged}  />
                            <label htmlFor="cb_field_proposal_awards"> Proposals</label>
                        </div>

                        <div id="search_option_publications" className={css(styles.searchInOption)} >
                            <input id="cb_field_publications" type="checkbox"  defaultChecked={this.state.isPublicationSelected} onChange={this.onPublicationChanged}/>
                            <label htmlFor="cb_field_publications">Publications</label>
                        </div>

                    </div >
                    
                    <div id="seperator" className={css(styles.seperator)} >

                    </div>  
                    
                    <div>
                        <div id="search_option_title" className={css(styles.searchInOption)} >
                            <input id="cb_field_title" type="checkbox" defaultChecked={this.state.isTitleSelected} onChange={this.onTitleChanged}/>
                            <label htmlFor="cb_field_title">Title</label>
                        </div>
                        <div id="search_option_abstracts" className={css(styles.searchInOption)} >
                            <input id="cb_field_abstracts" type="checkbox" defaultChecked={this.state.isAbstractSelected} onChange={this.onAbstractChanged} />
                            <label htmlFor="cb_field_abstracts">Abstract</label>
                        </div>
                    </div>
                </div>

                
                <div className={css(styles.sectionlabel)}>
                    Year
                </div>

                <div id="range" className={css(styles.range)} >
                    <div>
                        From
                    </div>                    
                    <OutsideClickHandler className={css(styles.dropdown)} onOutsideClick={this.onStartOutsideClicked}>
                        <Button color="link" className={css(styles.date)} onClick={this.onStartYearClicked} >
                            FY {this.state.startYear}
                        </Button>
                        <div className={css(styles.dropdown_content)} style={startYearDropDownContentStyle}  >
                            <YearPicker 
                                    selectedStartYear={this.state.startYear}
                                    selectedEndYear={this.state.endYear}
                                    onYearSelected={this.onStartYearSelected}
                                    isStartYear={true}/>                                
                        </div>
                    </OutsideClickHandler>  
                    <div>
                        to
                    </div>
                    <OutsideClickHandler className={css(styles.dropdown)} onOutsideClick={this.onEndOutsideClicked} >
                        <Button color="link" className={css(styles.date)} onClick={this.onEndYearClicked} >
                            FY {this.state.endYear}
                        </Button>
                        <div className={css(styles.dropdown_content)} style={endYearDropDownContentStyle}  >
                            <YearPicker 
                                    selectedStartYear={this.state.startYear}
                                    selectedEndYear={this.state.endYear}
                                    onYearSelected={this.onEndYearSelected}
                                    isStartYear={false}/>                                
                        </div>
                    </OutsideClickHandler>  
                </div>

                <div id="sponsor_container">
                    <div className={css(styles.sectionlabel)}>
                        Sponsor
                    </div>
                    <Select 
                        multi={true}
                        searchBy="name"
                        labelField="name"
                        valueField="id"
                        options={this.state.agencies}
                        onChange={this.onSelectedAgenciesChannged}
                        placeholder={"+ click to add"}
                        className={css(styles.agenciesDropDown)}
                    />
                </div>
                
                <div id="error" style={inputFieldStyle}>
                    {this.state.inputFieldError}
                </div>

                <Button className={css(styles.searchButton)} onClick={this.onSearchButtonClicked} >
                    Search
                </Button>

                

            </div>
            
        );
    }

    private onSelectedAgenciesChannged = (agencies: FundingAgency[]) => {
        this.setState({...this.state, selectedAgencies: agencies})
    }

    private onKeyPhraseChanged = (event: any) => {
        this.setState({...this.state, keyphrase: event.target.value})
    }

    private onStartOutsideClicked = () => {
        this.setState({...this.state, isStartYearDialogVisible: false})
    }

    private onStartYearClicked = (event: any) => {
        this.setState({...this.state, isStartYearDialogVisible: !this.state.isStartYearDialogVisible})
    }

    private onStartYearSelected = (year: number) => {
        if(year <= this.state.endYear && this.state.endYear - year <= 10){
            this.setState({...this.state, startYear: year, isStartYearDialogVisible: false})
        }
    }
    
    private onEndOutsideClicked = () => {
        this.setState({...this.state, isEndYearDialogVisible: false})
    }

    private onEndYearClicked = (event: any) => {
        this.setState({...this.state, isEndYearDialogVisible: !this.state.isEndYearDialogVisible})
    }

    private onEndYearSelected = (year: number) => {
        if(year >= this.state.startYear && year - this.state.startYear <= 10){
            this.setState({...this.state, endYear: year, isEndYearDialogVisible: false})
        }
    }
    
    private onFirstNameChange = (event: any) => {
        this.setState({...this.state, firstName: event.target.value})
    }

    private onLastNameChange = (event: any) => {
        this.setState({...this.state, lastName: event.target.value})
    }

    private onFacultyChanged = (event: any) => {
        this.setState({...this.state, isFacultySelected: event.target.checked})
    }
    private onSponsorChanged = (event: any) => {
            this.setState({...this.state, isSponsorSelected: event.target.checked})
        }

    private onProposalAwardsChanged = (event: any) => {
        this.setState({...this.state, isProposalAwardSelected: event.target.checked})
    }

    private onPublicationChanged = (event: any) => {
        this.setState({...this.state, isPublicationSelected: event.target.checked})
    }

    private onTitleChanged = (event: any) => {
        this.setState({...this.state, isTitleSelected: event.target.checked})
    }

    private onAbstractChanged = (event: any) => {
        this.setState({...this.state, isAbstractSelected: event.target.checked})
    }

    private onSearchButtonClicked = (event: any) => {
        console.log(this.state)
        if(this.state.firstName.trim().length === 0 &&
         this.state.lastName.trim().length === 0 &&
         this.state.keyphrase.trim().length === 0){
            this.setState({...this.state, isInputFieldError: true,
                                          inputFieldError: "Please enter either First name, Last name or Keyphrase"})
        }else if(!this.state.isAbstractSelected &&
                 !this.state.isProposalAwardSelected &&
                 !this.state.isSponsorSelected &&
                 !this.state.isFacultySelected &&
                 !this.state.isPublicationSelected
                 ){
            this.setState({...this.state, isInputFieldError: true,
                             inputFieldError: "Please select either Proposal, Awards or Publications"})
        }else if(!this.state.isTitleSelected &&
            !this.state.isAbstractSelected
            ){
            this.setState({...this.state, isInputFieldError: true,
                        inputFieldError: "Please select either Title or Abstract"})
        }        
        else{
            // build the search options
            const searchOptions = new SearchOptions();
            searchOptions.firstName = this.state.firstName;
            searchOptions.lastName = this.state.lastName;
            searchOptions.keyPhrase = this.state.keyphrase;
            searchOptions.isAbstractChecked = this.state.isAbstractSelected;
            searchOptions.isProposalAwardChecked = this.state.isProposalAwardSelected;
            searchOptions.isFacultyChecked =this.state.isFacultySelected;
            searchOptions.isSponsorChecked =this.state.isSponsorSelected;
            searchOptions.isPublicationChecked = this.state.isPublicationSelected;
            searchOptions.isTitleChecked = this.state.isTitleSelected;
            searchOptions.isAbstractChecked = this.state.isAbstractSelected;
            searchOptions.startYear = this.state.startYear;
            searchOptions.endYear = this.state.endYear;
            searchOptions.agencies = this.state.selectedAgencies;

            // stringify the options
            const options_string = JSON.stringify(searchOptions);

            // redirect to the search list page
            this.props.history.push(`/searchlist?options=${options_string}`)
        }        
    }


}


// WEBPACK FOOTER //
// ./src/pages/SearchPage.tsx